var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5435 4.16683C13.3574 4.32563 14.1055 4.72371 14.6919 5.31011C15.2783 5.89651 15.6763 6.64455 15.8352 7.4585M12.5435 0.833496C14.2345 1.02136 15.8115 1.77864 17.0154 2.981C18.2192 4.18336 18.9785 5.75934 19.1685 7.45016M18.3352 14.1002V16.6002C18.3361 16.8322 18.2886 17.062 18.1956 17.2746C18.1026 17.4873 17.9662 17.6782 17.7952 17.835C17.6242 17.9919 17.4223 18.1114 17.2024 18.1858C16.9826 18.2601 16.7496 18.2877 16.5185 18.2668C13.9542 17.9882 11.491 17.1119 9.32682 15.7085C7.31334 14.429 5.60626 12.722 4.32682 10.7085C2.91846 8.5345 2.04202 6.05932 1.76848 3.4835C1.74766 3.25305 1.77505 3.0208 1.8489 2.80152C1.92275 2.58224 2.04146 2.38074 2.19745 2.20985C2.35345 2.03896 2.54332 1.90242 2.75498 1.80893C2.96663 1.71544 3.19543 1.66705 3.42682 1.66683H5.92682C6.33124 1.66285 6.72331 1.80606 7.02995 2.06977C7.33659 2.33349 7.53688 2.6997 7.59348 3.10016C7.699 3.90022 7.89469 4.68577 8.17682 5.44183C8.28894 5.7401 8.3132 6.06426 8.24674 6.3759C8.18028 6.68753 8.02587 6.97359 7.80182 7.20016L6.74348 8.2585C7.92978 10.3448 9.6572 12.0722 11.7435 13.2585L12.8018 12.2002C13.0284 11.9761 13.3144 11.8217 13.6261 11.7552C13.9377 11.6888 14.2619 11.713 14.5601 11.8252C15.3162 12.1073 16.1018 12.303 16.9018 12.4085C17.3066 12.4656 17.6763 12.6695 17.9406 12.9814C18.2049 13.2933 18.3453 13.6915 18.3352 14.1002Z",
    stroke: "#163165",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCircle);
export default __webpack_public_path__ + "static/media/call-circle.2c98385590886ca95cf37db5f036947e.svg";
export { ForwardRef as ReactComponent };